"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _stripCacheKeysFromData = _interopRequireDefault(require("@devsta/strip-cache-keys-from-data"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  mutation UpdateStoryboard($input: StoryboardInput!, $storyboardId: String!) {\n    updateStoryboard(input: $input, storyboardId: $storyboardId) {\n     storyboardId\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var updateStoryboardQuery = (0, _graphqlTag.default)(_templateObject());

var updateStoryboard = function updateStoryboard(storyboardId) {
  return {
    mutation: updateStoryboardQuery,
    module: 'storyboards',
    buildVariables: function buildVariables(_ref) {
      var _ref$storyboard = _ref.storyboard,
          storyboard = _ref$storyboard === void 0 ? {} : _ref$storyboard,
          _ref$shots = _ref.shots,
          shots = _ref$shots === void 0 ? [] : _ref$shots;
      var shotsWithoutTempId = shots.map(function (_ref2, index) {
        var tempId = _ref2.tempId,
            rest = (0, _objectWithoutProperties2.default)(_ref2, ["tempId"]);
        return _objectSpread({}, rest, {
          position: index
        });
      });
      var organisationId = storyboard.organisationId,
          id = storyboard.storyboardId,
          permissions = storyboard.permissions,
          rest = (0, _objectWithoutProperties2.default)(storyboard, ["organisationId", "storyboardId", "permissions"]);
      var storyboardInput = (0, _stripCacheKeysFromData.default)(rest);
      return {
        input: _objectSpread({}, storyboardInput, {
          shots: (0, _stripCacheKeysFromData.default)(shotsWithoutTempId)
        }),
        storyboardId: storyboardId
      };
    }
  };
};

var _default = updateStoryboard;
exports.default = _default;